import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiDeleteStoreRequest,
    type OpenApiDeleteStoreResponseSuccess,
    OpenApiDeleteStoreUrl,
    type OpenApiDeletionFormRequest,
    type OpenApiDeletionFormResponseSuccess,
    OpenApiDeletionFormUrl,
} from '#shared/api/schema';

const storeDeletionApi = createApi({
    name: 'entities/store/api/deletion',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            sendDeletionForm: builder.mutation<OpenApiDeletionFormResponseSuccess, OpenApiDeletionFormRequest>({
                query: (payload) => {
                    return {
                        url: OpenApiDeletionFormUrl,
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
            deleteStore: builder.mutation<OpenApiDeleteStoreResponseSuccess, OpenApiDeleteStoreRequest>({
                query: (payload) => {
                    return {
                        url: OpenApiDeleteStoreUrl,
                        method: 'POST',
                        body: payload,
                    };
                },
            }),
        };
    },
});

export const storeDeleteSendForm = storeDeletionApi.endpoints.sendDeletionForm.mutate;
export const storeDelete = storeDeletionApi.endpoints.deleteStore.mutate;
